<banner-app
  [Fixtop]="''"
  [retroSelected]="false"
  [Loader]="true"
  [showPromo]="true"
  class="mobility-loader__banner"
></banner-app>
<div class="mobility-loader__container">
  <div class="mobility-loader__gif-container">
    <img
      src="./assets/img/Loader_1024x576_alfa - copia.gif"
      class="mobility-loader__gif"
      loading="lazy"
      alt="seguro de moto precio"
    />
  </div>
  <p class="mobility-loader__text">Estamos consultando tus datos...</p>
</div>
